Vue.component('assessment', {
    props: ['id'],
    data() {
        return {
            assessment : null,
            assessmentTemplate : {
                name : null,
                notes : null,
                assessment_commodities : [],
            },
            tab: 'input',
            calculating: false,
        }
    },
    computed: {
        //
    },
    methods: {
        loadAssessment() {
            if (this.id) {
                axios.get('/assessments/'+ this.id)
                     .then(response => {
                        this.assessment = response.data;
                        this.assessment.assessment_commodities.forEach(row => {
                            row.amount = numeral(row.amount).format('0.[00]');
                        });
                     });
            } else {
                this.assessment = _.cloneDeep(this.assessmentTemplate);
            }
        },
        checkCalculationStatus() {
            axios.get('/assessments/'+ this.assessment.id)
                 .then(response => {
                    this.assessment = response.data;

                    if (this.assessment.calculating) {
                        setTimeout(() => {
                            this.checkCalculationStatus();
                        }, 3000);
                    } else {
                        this.calculating = false;

                        if (this.assessment.has_error) {
                            this.tab = 'input';
                        } else {
                            if (this.tab == 'input') {
                                this.tab = 'map';
                            }
                        }
                    }
                 });
        },
        calculate() {
            if (!this.assessment.id) {
                alert('No assessment found.');
            }

            this.calculating = true;

            axios.post('/assessments/'+ this.assessment.id +'/calculate')
                 .then(response => {
                    setTimeout(() => {
                        this.checkCalculationStatus();
                    }, 3000)
                 });
        },
        exportUrl(type) {
            if (!this.assessment) {
                return null;
            }
            if (!this.assessment.id) {
                return null;
            }

            return '/assessments/'+ this.assessment.id +'/export/'+ type;
        }
    },
    mounted() {
        this.loadAssessment();

        this.eventHub.$on('calculate', () => {
            this.calculate();
        });

        this.eventHub.$on('assessmentCreated', (assessment) => {
            this.assessment = assessment;
            window.history.pushState('', '', '/assessments/'+ assessment.id +'/edit');
        });
    }
});